import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { booleanArray2jdug9b51huk7 as booleanArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3qslfm3vqg6y3 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz as get_EMPTY_SERIALIZER_ARRAY } from './PluginHelperInterfaces.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from './Platform.common.mjs';
import { CLASS_getInstance25nhr3t715wdo as CLASS_getInstance } from '../descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from './Platform.mjs';
import {
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_elementDescriptors13xxljc24xo44 as get_elementDescriptors,
} from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.l1y_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.n3();
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.n1y_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.n3();
}
function buildIndices($this) {
  var indices = HashMap().r8();
  var inductionVariable = 0;
  var last = $this.g1y_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.g1y_1[i];
      indices.x4(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return (p0) => _get_childSerializers__7vnyfa(p0);
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return (p0) => p0.k1z();
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return (p0) => _get__hashCode__tgwhef(p0);
}
var PluginGeneratedSerialDescriptorClass;
function PluginGeneratedSerialDescriptor() {
  if (PluginGeneratedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, generatedSerializer, elementsCount) {
        generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
        this.c1y_1 = serialName;
        this.d1y_1 = generatedSerializer;
        this.e1y_1 = elementsCount;
        this.f1y_1 = -1;
        var tmp = this;
        var tmp_0 = 0;
        var tmp_1 = this.e1y_1;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_2 = Array(tmp_1);
        while (tmp_0 < tmp_1) {
          tmp_2[tmp_0] = '[UNINITIALIZED]';
          tmp_0 = tmp_0 + 1 | 0;
        }
        tmp.g1y_1 = tmp_2;
        var tmp_3 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.e1y_1;
        tmp_3.h1y_1 = Array(size);
        this.i1y_1 = null;
        this.j1y_1 = booleanArray(this.e1y_1);
        this.k1y_1 = emptyMap();
        var tmp_4 = this;
        var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_4.l1y_1 = lazy(tmp_5, () => {
          var tmp0_safe_receiver = this.d1y_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b20();
          return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
        });
        var tmp_6 = this;
        var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_6.m1y_1 = lazy(tmp_7, () => {
          var tmp0_safe_receiver = this.d1y_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c20();
          var tmp;
          if (tmp1_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().h2(tmp1_safe_receiver.length);
            var inductionVariable = 0;
            var last = tmp1_safe_receiver.length;
            while (inductionVariable < last) {
              var item = tmp1_safe_receiver[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              var tmp$ret$5 = item.a1n();
              destination.i2(tmp$ret$5);
            }
            tmp = destination;
          }
          return compactArray(tmp);
        });
        var tmp_8 = this;
        var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_8.n1y_1 = lazy(tmp_9, () => hashCodeImpl(this, this.k1z()));
      }
      d1o() {
        return this.c1y_1;
      }
      y1p() {
        return this.e1y_1;
      }
      w1p() {
        return CLASS_getInstance();
      }
      z1p() {
        var tmp0_elvis_lhs = this.i1y_1;
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      a1r() {
        return this.k1y_1.v4();
      }
      k1z() {
        var tmp0 = this.m1y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
        return tmp0.n3();
      }
      l1z(name, isOptional) {
        this.f1y_1 = this.f1y_1 + 1 | 0;
        this.g1y_1[this.f1y_1] = name;
        this.j1y_1[this.f1y_1] = isOptional;
        this.h1y_1[this.f1y_1] = null;
        if (this.f1y_1 === (this.e1y_1 - 1 | 0)) {
          this.k1y_1 = buildIndices(this);
        }
      }
      p1y(name, isOptional, $super) {
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.l1z(name, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.l1z.call(this, name, isOptional);
        }
        return tmp;
      }
      q1y(annotation) {
        // Inline function 'kotlin.let' call
        var it = this.h1y_1[this.f1y_1];
        var tmp;
        if (it == null) {
          var result = ArrayList().h2(1);
          this.h1y_1[this.f1y_1] = result;
          tmp = result;
        } else {
          tmp = it;
        }
        var list = tmp;
        list.i2(annotation);
      }
      o1y(a) {
        if (this.i1y_1 == null) {
          this.i1y_1 = ArrayList().h2(1);
        }
        ensureNotNull(this.i1y_1).i2(a);
      }
      d1q(index) {
        return getChecked(_get_childSerializers__7vnyfa(this), index).a1n();
      }
      e1q(index) {
        return getChecked_0(this.j1y_1, index);
      }
      c1q(index) {
        var tmp0_elvis_lhs = getChecked(this.h1y_1, index);
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      a1q(index) {
        return getChecked(this.g1y_1, index);
      }
      b1q(name) {
        var tmp0_elvis_lhs = this.k1y_1.u4(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof PluginGeneratedSerialDescriptor())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.d1o() === other.d1o())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.k1z(), other.k1z())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.y1p() === other.y1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.y1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.d1q(index).d1o() === other.d1q(index).d1o())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.d1q(index).w1p(), other.d1q(index).w1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    initMetadataForClass($, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    PluginGeneratedSerialDescriptorClass = $;
  }
  return PluginGeneratedSerialDescriptorClass;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.y1p());
  var tmp_0 = _this__u8e3s4.d1o() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, (i) => _this__u8e3s4.a1q(i) + ': ' + _this__u8e3s4.d1q(i).d1o());
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.d1o());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.d1o();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.w1p();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
//region block: exports
export {
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  hashCodeImpl as hashCodeImplfv8qiy3re24s,
  toStringImpl as toStringImpl1y3u8fza7vdq,
};
//endregion

//# sourceMappingURL=PluginGeneratedSerialDescriptor.mjs.map
